import { render, staticRenderFns } from "./propertyDetails.vue?vue&type=template&id=059f3b83&scoped=true"
import script from "./propertyDetails.vue?vue&type=script&lang=js"
export * from "./propertyDetails.vue?vue&type=script&lang=js"
import style0 from "./propertyDetails.vue?vue&type=style&index=0&id=059f3b83&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "059f3b83",
  null
  
)

export default component.exports